import React, { useState, useEffect, useContext } from "react";
import ActiveRequest from "./ActiveRequest";
import { getActiveRequests } from "../../api/requests";
import "../CSS/RequestsList.css";
import AuthContext from "../../context/AuthContext";
import { Redirect } from "react-router";

import {getUserDetails} from '../../api/users'

export default function RequesStatusPage() {

  const [listRequests, setListRequests] = useState([]);
  const [loading, setloading] = useState(true);
  const [details, setDetails] = useState({
  
  } as any);
  const [isData, setIsData] = useState(false);
  const { user }: any = useContext(AuthContext);
  

  useEffect(() => {
    if (listRequests.length != 0 || isData){
      setloading(false);
    }

  }, [listRequests]);

  useEffect(() => {
    if (user) {
      getUserDetails(user.uid, "donor").then(data => {
        setDetails({ ...data });
      })
    }
  }, []);

  
  useEffect(() => {
    if (details.bloodGroup) {

      getActiveRequests(details.bloodGroup, details.city, details.covidRecovered)
        .then((data: any) => {
          if(data){
            setIsData(true);
          }
          setListRequests(data);
        })
        // .catch((err: any) => console.log(err));
    }
  }, [details]);

  const activeRequests = listRequests.map((request: any, index: number) => (
    <ActiveRequest key={index} info={request} />
  ));
  
  // Only donor should access this page
  if (user && user.userType !== "donor") {
    return <Redirect to="/" />;
  }

  return (
    <div id="Requests-container" className="container">
      <div className="table-responsive" id="Inner-container">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Phone</th>
              <th scope="col">City</th>
              <th scope="col">Email</th>
              <th scope="col">Blood</th>
              <th scope="col">Urgent</th>
              <th scope="col">Transportation</th>
              <th scope="col">Type</th>
              <th scope="col">Hospital</th>
              <th scope="col">Status</th>
            </tr>
          </thead>
          {loading ? 
            <div id="loading-requests" className="spinner-border text-dark" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            :
          <tbody>{activeRequests}</tbody>}
        </table>
        {listRequests.length === 0 && !loading ? <p className="no-data-message">There are no requests compatible with you right now.</p> : null}
      </div>
    </div>
  );
}
